import React, { Component } from "react";
import { connect } from "react-redux";
import Auxiliary from "../../hoc/Auxiliary/Auxiliary";
import StringInput from "../../components/Input/StringInput/StringInput";
import Button from "../../components/Button/Button";
import { formValidation, filterErrorHandler } from '../../hoc/Shared/utility';
import Swal from "sweetalert2";
import Skeleton from 'react-loading-skeleton';
// import moment from "moment";
import { withNamespaces } from "react-i18next";
import ValidationError from "../../components/ValidationError/ValidationError";
import Select from "../../components/Input/Select/Select";
// import NumberInput from "../../components/Input/NumberInput/NumberInput";
// import DateTimePicker from '../../components/DateTimePicker/DateTimePicker';
import * as actions from '../../store/ducks/slotFreeSpin/actions';

class SlotFreeSpinCreate extends Component 
{
    constructor(props) 
    {
        super(props);
        this.state = 
        {
            formFilter: 
            {
                reference_code: '',
                round: '',
                bet_scale: '',
                valid_period: '',
                vendor_id: '',
            },
            dropDown:
            {
                vendor: [],
                round: [],
                betScale: [],
                validPeriod: [],
            },
        };
        this.onInputChange = this.onInputChange.bind(this);
    }

    componentDidMount() 
    {
        this.props.funcGetDropDown(); // get filter drop down
        formValidation('free_spin_form');
    }

    shouldComponentUpdate(nextProps, nextState)
    {
    	const { t } = this.props;
        if (nextProps.store !== this.props.store && nextProps.store!==undefined)
        {
            let success = (nextProps.store.responseCode === 200 && nextProps.store.msgType === 'success') ? true : false;
            if(nextProps.store.responseCode === 200 && nextProps.store.msgType === 'success')
            {
                Swal.fire({
                    icon: 'success',
                    title: t('global.success'),
                    html: t('global.record-saved'),
                    showConfirmButton: true
                }).then(() =>
                {
                    this.props.refreshHandler();
                    this.props.changePageHandler('listing');
                });
            }
            else
            {
                this.setState({
                    touched: (success) ? false : true,
                    errMsg: (success) ? [] : nextProps.store.message
                });
                Swal.close();
            }
        }

        if (nextProps.dropDown !== this.props.dropDown && nextProps.dropDown!==undefined)
        {
            if(nextProps.dropDown.responseCode === 200 && nextProps.dropDown.msgType === 'success')
            {
                let newDropDown = Object.assign({}, this.state.dropDown);

                newDropDown['round'] = nextProps.dropDown.data.round.map((val, idx) =>
                {
                    return {label: val, value: val};
                    
                });

                newDropDown['vendor'] = nextProps.dropDown.data.vendor.map((val, idx) =>
                {
                    return {...val, vendor: t(`vendor.${val.slug}`)};
                });

                newDropDown['betScale'] = nextProps.dropDown.data.bet_scale.map((val, idx) =>
                {
                    return {label: val, value: val};
                });

                newDropDown['validPeriod'] = nextProps.dropDown.data.valid_period.map((val, idx) =>
                {
                    return {label: val.toString().toUpperCase(), value: val};
                });

                this.setState({
                    loading: false,
                    dropDown: newDropDown,
                });
            }
            else
            {
                this.setState({
                    loading: false,
                }, () => 
                {
                    filterErrorHandler(nextProps.dropDown.message);
                });
            }
        }

        return true;
    }

    onInputChange = (event) =>
    {
        // console.log(event.target.id+' | '+event.target.value);
        let newInput = Object.assign({}, this.state.formFilter);
        newInput[event.target.id] = event.target.value;
        
        this.setState({
            formFilter: newInput,
        });
    }

    submitHandler = (e) =>
    {
        // console.log('submitHandler :', this.state);
        e.preventDefault();
        const { t } = this.props;
        Swal.fire({
            title: t('validation.confirmation'), 
            text: t('validation.confirmation_check'),
            icon: 'warning',
            confirmButtonText: t('global.save'),
            showDenyButton: true,
            denyButtonText: t('global.cancel'),
        }).then((result) => 
        {
            if (result.isConfirmed) 
            {
                Swal.fire({
                    allowOutsideClick: false,
                    allowEscapeKey: false,
                    allowEnterKey: false,
                    didOpen: () => 
                    {
                        Swal.showLoading()
                    }
                });

                let formData = new FormData();
                formData.append('reference_code',this.state.formFilter.reference_code);
                formData.append('vendor_id',this.state.formFilter.vendor_id);
                formData.append('round',this.state.formFilter.round);
                formData.append('valid_period',this.state.formFilter.valid_period);
                formData.append('bet_scale',this.state.formFilter.bet_scale);

                // for (var pair of formData.entries()) 
                // {
                //      console.log(pair[0]+ ' = ' + pair[1]);
                // }

                this.props.funcStore(formData);
            }
        });
    }

    render()
    {
        const { t } = this.props;
        // let statusArr = [
        //     { label: t("global.active"), value: 1 },
        //     { label: t("global.inactive"), value: 0 },
        // ];

        return (
            <Auxiliary>
                <div className="breadcrumb-header">
                    <div className='d-flex'>
                        <div className='my-auto'>
                            <Button
                                typeButton="button"
                                classValue="btn btn-back-outline"
                                idValue="back"
                                buttonName={<i className="angle fe fe-chevron-left"></i>}
                                clicked={() => this.props.changePageHandler('listing')}
                            />
                        </div>
                    </div>
                    <div className="my-auto">
                        <div className="d-flex">
                            <h4 className="content-title mb-0 my-auto ml-2">{t("side-bar.slot_free_spin")}</h4>
                        </div>
                    </div>
                </div>
                <div className="row row-sm">
                    <div className="col-lg-12 col-xl-12 col-md-12 col-sm-12">
                        <div className="card  box-shadow-0">
                            <div className="card-header">
                                <h4 className="card-title mb-1">{t('slot-free-spin.add-free-spin')}</h4>
                            </div>
                            <div className="card-body pt-0">
                                
                                {/* <form method="post" id="reward_item_form" className="form-horizontal" encType="multipart/form-data" onSubmit={this.submitHandler} noValidate> */}
                                <form method='post' id='free_spin_form' className='form-horizontal' onSubmit={this.submitHandler} noValidate>
                                    <ValidationError formName='free_spin_form' touched={this.state.touched} message={this.state.errMsg}/>
                                    {this.state.loading
                                    ? 
                                    <Skeleton count={4}/> 
                                    :
                                    <>
                                        <div className="row">
                                            <div className="col-md-4">
                                                <div className="form-group">
                                                    <label>{t('slot-free-spin.reference-code')}</label>
                                                    <StringInput
                                                        onChange={(event) => this.onInputChange(event)}
                                                        id='reference_code'
                                                        name='reference_code'
                                                        value={this.state.formFilter.reference_code || ''}
                                                    />
                                                </div>
                                            </div>
                                            <div className="col-md-4">
                                                <div className="form-group">
                                                <label>{t('slot-free-spin.game-vendor')}</label>
                                                    <Select  
                                                        id="vendor_id"
                                                        name="vendor_id"
                                                        className='form-control'
                                                        getOptionValue='id'
                                                        getOptionLabel='vendor'
                                                        emptyValue={true}
                                                        options={this.state.dropDown.vendor}
                                                        onChange={(event) => this.onInputChange(event)}
                                                        value={this.state.formFilter.vendor_id || ''}
                                                        required
                                                    />
                                                </div>
                                            </div>
                                            <div className="col-md-4">
                                                <div className="form-group">
                                                    <label>{t('slot-free-spin.free-round')}</label>
                                                    <Select
                                                        id="round"
                                                        name="round"
                                                        className="form-control"
                                                        emptyValue={true}
                                                        options={this.state.dropDown.round}
                                                        onChange={(event) => this.onInputChange(event)}
                                                        value={this.state.formFilter.round || ''}
                                                        required
                                                    />
                                                </div>
                                            </div>
                                            <div className="col-md-4">
                                                <div className="form-group">
                                                    <label>{t('slot-free-spin.bet-scale')}</label>
                                                    <Select
                                                        id="bet_scale"
                                                        name="bet_scale"
                                                        className="form-control"
                                                        emptyValue={true}
                                                        options={this.state.dropDown.betScale}
                                                        onChange={(event) => this.onInputChange(event)}
                                                        value={this.state.formFilter.bet_scale || ''}
                                                        required
                                                    />
                                                </div>
                                            </div>
                                            <div className="col-md-4">
                                                <div className="form-group">
                                                    <label>{t('slot-free-spin.valid-period')}</label>
                                                    <Select
                                                        id="valid_period"
                                                        name="valid_period"
                                                        className="form-control"
                                                        emptyValue={true}
                                                        options={this.state.dropDown.validPeriod}
                                                        onChange={(event) => this.onInputChange(event)}
                                                        value={this.state.formFilter.valid_period || ''}
                                                        required
                                                    />
                                                </div>
                                            </div>
                                        </div>

                                        <hr className="pt-4" />

                                        <div className="form-group mb-0 justify-content-end">
                                            <div>
                                                <Button
                                                    id="submit"
                                                    classValue="btn btn-blue"
                                                    typeButton="submit"
                                                    buttonName={t('global.save')}
                                                />
                                            </div>
                                        </div>
                                    </>}
                                </form>
                            </div>
                        </div>
                    </div>
                </div>
            </Auxiliary>
        );
    }
}

//Received the response from the redux calling the api response
const mapStateToProps = state =>
{
    return {
        store: state.slotFreeSpin.store,
        dropDown: state.slotFreeSpin.dropDown,
        currentUser: state.currentUser.data,
    }
};

//Using the redux calling api methods
const mapDispatchToProps = dispatch =>
{
    return {
        funcStore: (data) => dispatch(actions.store(data)),
        funcGetDropDown: () => dispatch(actions.getDropDown()),
    }
};

// Connect redux
export default connect(mapStateToProps, mapDispatchToProps) (withNamespaces('translation')(SlotFreeSpinCreate));